import { useEffect, useState } from "react";
import arrowLeft from "../../../Assets/icon/arrow-narrow-left.svg";
import { useNavigate } from "react-router-dom";
import { useHeader } from "../../../Providers/HeaderContextProvider";
import "./style.css";
import "../../../Pages/TermsofUse/style.css";
import ToggleButton from "../../../Components/ToggleButton/ToggleButton";
import {
  getNotificationSettings,
  updateNotificationSettings,
} from "../../../Services/settingsServices";
import GradientBackground from "../../../Components/AddRelationshipHeaderGradient";
import Loader from "react-js-loader"; // Add this if not already imported
import { positions } from "@mui/system";

function Communications() {
  const navigate = useNavigate();
  const { setHeaderContent } = useHeader();

  const [notificationSettings, setnotificationSettings] = useState({
    email_comm: false,
  });

  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    setHeaderContent(false);
    getNotificationSettings().then((e) => {
      setnotificationSettings({
        email_comm: e?.email_comm,
      });
    });
  }, []);

  // Auto-clear error after 3 seconds
  useEffect(() => {
    if (errorMessage) {
      const timer = setTimeout(() => setErrorMessage(""), 3000);
      return () => clearTimeout(timer);
    }
  }, [errorMessage]);

  const onToggleSelection = async (name) => {
    const updatedValue = !notificationSettings[name];
    setnotificationSettings((prev) => ({
      ...prev,
      [name]: updatedValue,
    }));

    try {
      setIsLoading(true);
      await updateNotificationSettings({ [name]: updatedValue });
    } catch (error) {
      // Rollback the change if update fails
      setnotificationSettings((prev) => ({
        ...prev,
        [name]: !updatedValue,
      }));
      setErrorMessage(error.response?.data?.message || "Something went wrong !");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <GradientBackground>
        <header className="termsofuse-header">
          {isLoading && (
            <div className="loader-df-container setting-communication">
              <Loader
                type="spinner-cub"
                bgColor={"#2D50A7"}
                color={"#3D6DEB"}
                size={45}
               
              />
            </div>
          )}
          <div className="termsofuse-gradient-background">
            <div className="termsofuse-nav-container">
              <div
                className="termsofuse-logo-container"
                onClick={() => navigate(-1)}
              >
                <img
                  src={arrowLeft}
                  alt="Back"
                  className="termsofuse-back-button"
                />
              </div>
              <h1 className="termsofuse-title">Communications</h1>
              <div className="termsofuse-space"></div>
            </div>
            <div className="termsofuse-last-subtext">Email</div>
          </div>
        </header>

        <div className="notification-set-hero-container">
          <div className="notification-set-accord">
            <div className="notification-set-accord-title-container">
              <div className="not-set-head">Week in review emails</div>
              <div className="not-set-sub">
                Lessons, content, insights connected to your Aris Portrait.
              </div>
            </div>
            <div>
              <ToggleButton
                isChecked={notificationSettings.email_comm}
                onChange={() => onToggleSelection("email_comm")}
                name={"email_comm"}
                disabled={isLoading}
              />
            </div>
          </div>

          {/* Error Message */}
          {errorMessage && (
            <div
              style={{ color: "red", textAlign: "center", marginTop: "20px" }}
            >
              {errorMessage}
            </div>
          )}
        </div>
      </GradientBackground>
    </div>
  );
}

export default Communications;
